// @ts-nocheck
import React, { FC, useEffect, useState } from 'react'

import { FormattedMessage } from 'react-intl'

import { Snackbar, Button, makeStyles } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles(() => ({
  alert: {
    color: '#fff',
    backgroundColor: '#ff9800'
  },
  button: {
    color: '#fff',
    backgroundColor: '#ff9800',
    '&:hover': {
      backgroundColor: '#ddac25'
    }
  }
}))

const scope = 'layouts.ServiceWorkerWrapper'

const ServiceWorkerWrapper: FC = () => {
  const s = useStyles()
  const [showReload, setShowReload] = useState(false)

  const reloadPage = (): void => {
    window.workbox.addEventListener('controlling', () => {
      window.location.reload()
    })

    setShowReload(false)

    window.workbox.messageSW({ type: 'SKIP_WAITING' })
  }

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      window.workbox !== undefined
    ) {
      const wb = window.workbox

      const promptNewVersionAvailable = (): void => {
        setShowReload(true)
      }

      wb.addEventListener('waiting', promptNewVersionAvailable)
      wb.addEventListener('externalwaiting', promptNewVersionAvailable)

      wb.register()
    }
  }, [])

  return (
    <Snackbar
      open={showReload}
      onClick={reloadPage}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        className={s.alert}
        variant="filled"
        action={
          <Button
            variant="text"
            className={s.button}
            size="small"
            onClick={reloadPage}
          >
            <FormattedMessage
              id={`${scope}.reloadButton`}
              defaultMessage="Reload"
            />
          </Button>
        }
      >
        <FormattedMessage
          id={`${scope}.reloadMessage`}
          defaultMessage="A new version is available!"
        />
      </Alert>
    </Snackbar>
  )
}

export default ServiceWorkerWrapper
